import { render, staticRenderFns } from "./OutboundConfirmDialog.vue?vue&type=template&id=b0faf51a&scoped=true&"
import script from "./OutboundConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./OutboundConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./OutboundConfirmDialog.vue?vue&type=style&index=0&id=b0faf51a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0faf51a",
  null
  
)

export default component.exports